import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import LeftLounge from '../components/LeftLounge';
import RightLounge from '../components/RightLounge';
import WdwLeftLounge from '../components/WdwLeftLounge';
import WdwRightLounge from '../components/WdwRightLounge';
import ModernThemeBanner from '../components/ModernThemeBanner';
import LoungeMaintenanceGate from '../components/LoungeMaintenanceGate';
import { ENABLE_SCROLL_TO_TOP } from '../constants/features';

export default function LoungeLayout() {
  const location = useLocation();
  const pathArray = location.pathname.split('/');

  useEffect(() => {
    if (ENABLE_SCROLL_TO_TOP) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  // Modern theme: scope all overrides under `.mw-lounge-modern`.
  const isDisneylandRoute =
    pathArray[1] === 'disneyland' ||
    pathArray[1] === 'loungeland' ||
    pathArray[1] === 'club333';
  const bgClassName = `mousewait-bg${
    isDisneylandRoute ? ' mw-lounge-modern' : ''
  }`;

  return (
    <div className={bgClassName}>
      {/*===== MW-Deshborad-sec Start =======*/}
      <div className='mousewait-deshborad'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='des-main-sec'>
              {/* ===leftbar start=== */}
              {pathArray[1] === 'loungeland' ||
              pathArray[1] === 'disneyland' || pathArray[1] === 'club333' ? (
                <LeftLounge />
              ) : (
                <WdwLeftLounge />
              )}

              {/* ===leftbar end=== */}
              {/* ===mid-sec start=== */}
              <LoungeMaintenanceGate>
                <Outlet />
              </LoungeMaintenanceGate>
              {/* ===mid-sec End=== */}
              {/* ===rightbar start=== */}
              {pathArray[1] === 'loungeland' ||
              pathArray[1] === 'disneyland' ? (
                <RightLounge />
              ) : (
                <WdwRightLounge />
              )}

              {/* ===rightbar End=== */}
            </div>
          </div>
        </div>
      </div>
      {isDisneylandRoute && <ModernThemeBanner />}
    </div>
  );
}
